import React, { Component } from 'react';
import './sec3.css';


const Sec3 = () => {
    return ( 
        <section className='sec3'>
         <div className='sec3-div'>
            <h1>Journey Through Time</h1>
            <p>Key moments that shaped a visionary life</p>

            <div class="timeline-container">
  <div class="timeline-line"></div>
  
  <div class="timeline-item">
    <div class="year">1452</div>
    <div class="dot"></div>
    <h3>Born in Vinci</h3>
    <p>Leonardo was born in the Tuscan hill town of Vinci, the illegitimate son of a notary.</p>
  </div>

  <div class="timeline-item">
    <div class="year">1472</div>
    <div class="dot"></div>
    <h3>Master Artist</h3>
    <p>Qualified as a master in the Guild of Saint Luke, the guild of artists and doctors of medicine.</p>
  </div>

  <div class="timeline-item">
    <div class="year">1482</div>
    <div class="dot"></div>
    <h3>Milan Court</h3>
    <p>Moved to Milan to work for the Duke, creating The Last Supper and countless inventions.</p>
  </div>

  <div class="timeline-item">
    <div class="year">1503</div>
    <div class="dot"></div>
    <h3>Mona Lisa</h3>
    <p>Began painting the Mona Lisa, the world's most famous portrait.</p>
  </div>

  </div>

         </div>
        </section>
     );
}
 
export default Sec3;